import React from 'react';
import commonResource from '../../locales/th/common.json';
import { DisclaimerWrapper } from './Disclaimer.style';

export const Disclaimer = (): React.ReactElement => {
  return <DisclaimerWrapper>{commonResource.disclaimer}</DisclaimerWrapper>;
};
